import {ExternalHosting, ToEmbedUrl} from './@types';

// video<oid>_<id> или clip<oid>_<id>
const VIDEO_ID    = /(?:video|clip)(-?\d+)_(\d+)/;
const EMBED_PATH  = '/video_ext.php';
const LAYER_PARAM = 'z';

const fromEmbedLink: ToEmbedUrl = (url) =>
    url.searchParams.has('oid') && url.searchParams.has('id')
        ? url.href
        : null
;

const buildEmbedUrl = (oid: string, id: string): string =>
    `https://vkvideo.ru/video_ext.php?oid=${oid}&id=${id}`
;

const fromVideoLink: ToEmbedUrl = ({pathname, searchParams}) => {
    const layerMatch         = searchParams.get(LAYER_PARAM)?.match(VIDEO_ID);
    const pathMatch          = pathname.match(VIDEO_ID);
    const [videoId, oid, id] = layerMatch ?? pathMatch ?? [];

    return oid && id
        ? buildEmbedUrl(oid, id)
        : null
    ;
};

const toVkvideoEmbed: ToEmbedUrl = (url) =>
    url.pathname === EMBED_PATH
        ? fromEmbedLink(url)
        : fromVideoLink(url)
;

export const vkvideoHosting: ExternalHosting = {
    hosts:   ['vkvideo.ru', 'vk.com', 'vk.ru'],
    toEmbed: toVkvideoEmbed,
};
